import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { AppStore, CurrentUserStore, GeotabConnector } from 'stores';
import ROIImage from 'assets/roi.png';

const Spacing = styled.div`
  height: 30px;
`;

const Item = styled.li`
  font-size: 18px;
`;

const Image = styled.img`
  display: block;
  max-width: 900px;
  width: 100%;
  margin-bottom: 20px;
`;

const LoginGeotab = observer(({ toggleSideBar }) => {
  const MESSAGE = 'Logging In';
  const [areCookiesEnable] = useState(AppStore.areCookiesEnable());
  const [isOnGeotabDashboard] = useState(AppStore.isOnGeotabDashboard());
  let triedToAuthenticate = false;

  const getGeotabCredentials = async () => {
    if (AppStore.getGeotabSSOVersion() > 1) {
      return GeotabConnector.getCredentials();
    }

    return new Promise((resolve) => {
      GeotabConnector.getCredentials((credentials, origin) => {
        resolve({ credentials, origin });
      });
    });
  };

  const loginWithCredentials = (credentials, origin) => {
    if (triedToAuthenticate) return;
    triedToAuthenticate = true;

    AppStore.addLoading(MESSAGE);
    CurrentUserStore.loginGeotab(
      credentials.database,
      credentials.sessionId,
      credentials.userName,
      origin,
      (success) => {
        AppStore.removeLoading(MESSAGE);
        if (success) {
          CurrentUserStore.getCurrentUser();
          toggleSideBar();
        }
      }
    );
  };

  useEffect(() => {
    toggleSideBar();

    const initializeGeotab = async () => {
      if (AppStore.isOnGeotabDashboard()) {
        // GeotabConnector.registerListener();
        const res = await getGeotabCredentials();
        const { credentials, origin } = res;
        if (credentials) {
          loginWithCredentials(credentials, origin);
        }
      }
    };

    initializeGeotab();
  }, []);

  const renderEnableCookieTutorial = () => (
    <div>
      <h3>
        Pitstop addin is only guaranteed to work on Google Chrome and Firefox
      </h3>
      <Image src={ROIImage} alt="ROI" />
      <h5>
        If your browser is not supported and you want to use Pitstop addin on
        it, you must enable Third-Party Cookies. Allowing Third-Party Cookies
        will allow tracking programs to track your web activity, so aways
        remember to disable it after leaving Pitstop.
      </h5>
      <h5>
        Alternativelly you can use any browser to access Pitstop without any
        additional step at{' '}
        <a href="https://dashboard.pitstopconnect.com/">
          https://dashboard.pitstopconnect.com
        </a>
      </h5>
      <Spacing />
      <h4>Brave</h4>
      <ol>
        <Item>Open settings</Item>
        <Item>Search for {'"Cookie Blocking"'}</Item>
        <Item>Set it to {'"Disabled"'}</Item>
      </ol>
      <h4>Safari</h4>
      <ol>
        <Item>Open Preferences</Item>
        <Item>Click on {'"Privacy"'} tab</Item>
        <Item>
          Disable {'"Website tracking -> Prevent cross-site tracking"'}
        </Item>
      </ol>
      <Spacing />
    </div>
  );

  return (
    <>
      {!isOnGeotabDashboard && (
        <h3>
          This page only works on{' '}
          <a href="https://geotab.com">https://geotab.com</a> addin
        </h3>
      )}
      {isOnGeotabDashboard && !areCookiesEnable && renderEnableCookieTutorial()}
    </>
  );
});

LoginGeotab.propTypes = {
  toggleSideBar: PropTypes.func.isRequired,
};

export default LoginGeotab;
